import { rmmMuteDescription as description } from './description';
import { muteAlert as execute } from './execute';

export { description, execute };
